
import {CodeNameTranslate} from "../../shared/models/code-name-translate";

export class TabItem extends CodeNameTranslate {
    constructor(id: number, selected: boolean, code: any, name: string, key: string, public readonly type: string,
                public readonly hotKey: string, public readonly tabName: string, public readonly procedure: string,
                public group: string, public readonly groupId: string, public readonly position: number,
                public readonly visibility: number, public readonly displayPlaceType: string,
                public readonly zoomFilterField: string){
        super(id, selected, code, name, key);
    }

    public clone = (): TabItem => {
        let clone = new TabItem(this.id, this.selected, this.code, this.name, this.key, this.type, this.hotKey,
            this.tabName, this.procedure, this.group, this.groupId, this.position, this.visibility, this.displayPlaceType,
            this.zoomFilterField);
        clone.findName = this.findName;
        clone.findCode = this.findCode;
        clone.disabled = this.disabled;
        return clone;
    }

}

export interface TabItem3 {
    id: number,
    selected: boolean,
    position: number
}

export class TabItem2 implements TabItem3{
    constructor(id: number, selected: boolean, public code: any, public name: string, public key: string, public readonly type: string, public readonly hotKey: string, public rowType: string){
        this.id = id;
        this.selected = selected;
        this.position = 0;
        this.keyStyle = 1;
    }
    public id: number;
    public selected: boolean;
    public position: number;
    public keyStyle: number;
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/tab-item.ts